import { Box, Inline, P, Stack } from "@adfenix/alexandria";
import { SolidArrowRight } from "@adfenix/icons";

import { useGetAgentById } from "api/queries/agentService";
import { userSelectedHq } from "atoms/auth";
import { useFeatureToggle } from "hooks/useFeatureToggle";
import { useCheckPermission } from "hooks/usePermissions";
import useUserInfo from "hooks/useUserInfo";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";
import styled from "styled-components";

const StyledProfileImage = styled.img`
  border-radius: 50%;
`;

const StyledInline = styled(Inline)`
  color: white;
`;

export const Profile = () => {
  const { userEmail, roleName, agentId } = useUserInfo();
  const hq = useRecoilValue(userSelectedHq);
  const hasPermission = useCheckPermission({ scope: "Agent", action: "Edit" });
  const profileEnabled = useFeatureToggle(hq?.id ?? "", "agent-profile", false);
  const { data } = useGetAgentById(profileEnabled ? agentId : undefined);

  if (
    !agentId &&
    (roleName === "AdfenixEngineering" || roleName === "AdfenixSupport")
  ) {
    return (
      <Box style={{ color: "white" }} pX="m">
        <P color="white" bold>
          {userEmail}
        </P>
        <P color="white">{roleName}</P>
      </Box>
    );
  }

  if (!hasPermission || !data || !profileEnabled) {
    return null;
  }

  return (
    <Link to={`${hq?.id ?? ":hqId"}/agent-profile/${agentId}`}>
      <StyledInline alignItems="center" gap="m" noWrap>
        {data.image && (
          <StyledProfileImage
            src={data.image}
            alt="profile-picture"
            style={{
              width: "50px",
              height: "50px",
              aspectRatio: "preserve",
              objectFit: "cover"
            }}
          />
        )}

        <Stack spacing="xs2">
          <P bold color="white">
            {userEmail}
          </P>
          <Inline alignItems="center" justifyContent="space-between">
            <P bold color="white">
              {roleName}{" "}
            </P>
            <SolidArrowRight fill="white" />
          </Inline>
        </Stack>
      </StyledInline>
    </Link>
  );
};
